'use client';

import React, { useEffect, useState } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

/**
 * React Query DevTools component that only renders on the client side
 * This prevents hydration mismatches in SSR applications
 */
export const QueryDevTools = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Only render DevTools after client-side hydration is complete
  if (!isMounted || process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
  );
};
